import PagePlaceholder from "../components/PagePlaceholder";

/**
 * The Findings view. Placeholder until the domain model is defined.
 */
function Findings() {
  return (
    <PagePlaceholder
      title="Findings"
      summary="Placeholder. Findings content is not defined yet — this view is a stand-in until the domain model lands."
    />
  );
}

export default Findings;
